/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Server classification, present for MCP server nodes
 */
export const ServerClass = {
  Gram: "gram",
  External: "external",
  Local: "local",
} as const;
/**
 * Server classification, present for MCP server nodes
 */
export type ServerClass = ClosedEnum<typeof ServerClass>;

/**
 * Graph tier. Origin nodes identify the hostname or client context that started the call, not the MCP server URL.
 */
export const EmployeeDataFlowNodeTier = {
  Origin: "origin",
  Client: "client",
  Server: "server",
  Tool: "tool",
} as const;
/**
 * Graph tier. Origin nodes identify the hostname or client context that started the call, not the MCP server URL.
 */
export type EmployeeDataFlowNodeTier = ClosedEnum<
  typeof EmployeeDataFlowNodeTier
>;

/**
 * A node in the employee data flow graph
 */
export type EmployeeDataFlowNode = {
  /**
   * Stable node ID
   */
  id: string;
  /**
   * Display label
   */
  label: string;
  /**
   * Server classification, present for MCP server nodes
   */
  serverClass?: ServerClass | undefined;
  /**
   * Graph tier. Origin nodes identify the hostname or client context that started the call, not the MCP server URL.
   */
  tier: EmployeeDataFlowNodeTier;
  /**
   * Total calls involving this node
   */
  totalCalls: number;
};

/** @internal */
export const ServerClass$inboundSchema: z.ZodMiniEnum<typeof ServerClass> = z
  .enum(ServerClass);

/** @internal */
export const EmployeeDataFlowNodeTier$inboundSchema: z.ZodMiniEnum<
  typeof EmployeeDataFlowNodeTier
> = z.enum(EmployeeDataFlowNodeTier);

/** @internal */
export const EmployeeDataFlowNode$inboundSchema: z.ZodMiniType<
  EmployeeDataFlowNode,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    label: z.string(),
    server_class: z.optional(ServerClass$inboundSchema),
    tier: EmployeeDataFlowNodeTier$inboundSchema,
    total_calls: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "server_class": "serverClass",
      "total_calls": "totalCalls",
    });
  }),
);

export function employeeDataFlowNodeFromJSON(
  jsonString: string,
): SafeParseResult<EmployeeDataFlowNode, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EmployeeDataFlowNode$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EmployeeDataFlowNode' from JSON`,
  );
}
